/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { getImageFile, fallbackImage } from 'utils/stringUtils';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import Hidden from '@material-ui/core/Hidden';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import StyledLink from 'components/StyledLink';
import reducer from 'containers/Blogs/reducer';
import { getBlogs } from 'containers/Blogs/actions';
import {
  makeSelectBlogs,
  makeSelectProcessing,
} from 'containers/Blogs/selectors';
import Skeleton from '@material-ui/lab/Skeleton';
import saga from 'containers/Blogs/saga';
import NavBarContext from '../../navBarContext';
import BlogMainItem from './BlogMainItem';

const useStyles = makeStyles(() => ({
  lists: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginTop: 28,
  },
  image: {
    width: '100%',
    height: 139,
    marginBottom: 6,
    objectFit: 'cover',
  },
  listItem: {
    width: 246,
    marginRight: 21,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: 15,
  },
  imageRoot: {
    width: 246,
  },
  name: {
    width: 246,
  },
}));

function BlogsContent({ type, clickHandler }) {
  const classes = useStyles();
  useInjectReducer({ key: 'blogs', reducer });
  useInjectSaga({ key: 'blogs', saga });

  const dispatch = useDispatch();
  const { blogs } = useContext(NavBarContext);
  const blogsData = useSelector(makeSelectBlogs());
  const processing = useSelector(makeSelectProcessing());
  useEffect(() => {
    if (type !== 'Latest') {
      dispatch(
        getBlogs({
          blogTypesFilters: [type],
        }),
      );
    }
  }, [type]);

  if (processing) return <Skeleton variant="react" height={200} width={801} />;
  const isLatest = type === 'Latest';
  const isAmbassadorBlog = type === 'Ambassador Blog';
  const data = type === 'Latest' ? blogs : _get(blogsData, 'hits');
  if (_isEmpty(data)) return null;
  const firstItem = isLatest ? data[0].fields : data[isAmbassadorBlog ? 4 : 0];
  const remainingItem = !isAmbassadorBlog
    ? data.slice(1, 4)
    : data.slice(7, 10);
  return (
    <>
      <BlogMainItem
        data={firstItem}
        isLatest={isLatest}
        clickHandler={clickHandler}
      />
      <Hidden xsDown>
        <div className={classes.lists} data-test-id="blogs-list">
          {remainingItem.map(el => {
            const finalFields = isLatest ? el.fields : el;
            const imageSrc = getImageFile(finalFields);
            const { slug, name } = finalFields;
            return (
              <StyledLink link={`/blogs/${slug}`} key={slug}>
                <div className={classes.listItem}>
                  <div className={classes.imageRoot}>
                    <img
                      src={imageSrc}
                      alt={name}
                      className={classes.image}
                      onError={e => {
                        e.target.src = fallbackImage;
                      }}
                      onClick={() => clickHandler(name, 'image')}
                    />
                  </div>
                  <div
                    className={classes.name}
                    onClick={() => clickHandler(name, 'text')}
                  >
                    <Typography variant="overline" color="textPrimary">
                      {name}
                    </Typography>
                  </div>
                </div>
              </StyledLink>
            );
          })}
        </div>
      </Hidden>
    </>
  );
}

BlogsContent.propTypes = {
  type: PropTypes.string,
  clickHandler: PropTypes.func,
};

export default BlogsContent;
